// extracted by mini-css-extract-plugin
export default {"tableFixHeadFoot":"AuditTrail_tableFixHeadFoot__GHlEy","tableCellAlignCenter":"AuditTrail_tableCellAlignCenter__lTGtG","footerAlignCenter":"AuditTrail_footerAlignCenter__IGTW8"};